import React from 'react';
import { CreateAccountForm } from '../components/Auth-Designer/CreateAccountForm';

const RegisterPage = () => {
  return (
    <main>
      <CreateAccountForm />
    </main>
  );
};

export default RegisterPage;